import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectLassoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M14.96 2.64001C15.94 2.84001 16.87 3.15001 17.73 3.55001C18.1 3.72001 18.55 3.57001 18.73 3.19001C18.91 2.82001 18.75 2.37001 18.37 2.19001C17.41 1.73001 16.36 1.39001 15.26 1.17001C14.85 1.09001 14.46 1.35001 14.37 1.75001C14.29 2.16001 14.55 2.55001 14.95 2.63001L14.96 2.64001Z"
        fill={color}
      />
      <path
        d="M8.95999 2.74C9.96999 2.55 11 2.36999 12.04 2.36999C12.45 2.36999 12.79 2.02 12.78 1.61C12.77 1.2 12.43 0.869995 12.02 0.869995C10.93 0.889995 9.83999 1.02 8.78999 1.26C8.38999 1.35 8.12999 1.76 8.22999 2.16C8.30999 2.51 8.61999 2.74 8.95999 2.74Z"
        fill={color}
      />
      <path
        d="M1.75 10.19C1.71 9.29 1.9 8.4 2.31 7.54C2.49 7.17 2.33 6.72 1.96 6.54C1.59 6.36 1.14 6.52 0.960002 6.89C0.440002 7.97 0.200002 9.1 0.250002 10.24C0.270002 10.64 0.600002 10.96 1 10.96C1.01 10.96 1.02 10.96 1.03 10.96C1.44 10.94 1.77 10.59 1.75 10.18V10.19Z"
        fill={color}
      />
      <path
        d="M14.21 17.01C13.25 17.18 12.26 17.26 11.28 17.22C10.84 17.22 10.52 17.53 10.5 17.94C10.49 18.35 10.81 18.7 11.22 18.72C12.3 18.76 13.4 18.68 14.46 18.49C14.87 18.42 15.14 18.03 15.07 17.62C15 17.21 14.61 16.94 14.2 17.01H14.21Z"
        fill={color}
      />
      <path
        d="M21.76 7.36999C21.93 7.74999 22.38 7.91999 22.75 7.74999C23.13 7.57999 23.3 7.13999 23.13 6.75999C22.68 5.75999 22.01 4.83999 21.14 4.02999C20.84 3.74999 20.36 3.76999 20.08 4.06999C19.8 4.36999 19.82 4.84999 20.12 5.12999C20.84 5.79999 21.4 6.54999 21.76 7.36999Z"
        fill={color}
      />
      <path
        d="M23.04 9.33999C22.63 9.28999 22.27 9.61999 22.23 10.03C22.16 10.92 21.87 11.79 21.38 12.62C21.17 12.97 21.28 13.44 21.64 13.65C21.99 13.86 22.45 13.75 22.67 13.39C23.29 12.36 23.65 11.27 23.74 10.14C23.77 9.72999 23.46 9.36999 23.05 9.32999L23.04 9.33999Z"
        fill={color}
      />
      <path
        d="M19.5 14.72C18.78 15.3 17.94 15.79 17.01 16.19C16.63 16.35 16.45 16.79 16.61 17.17C16.73 17.46 17.01 17.63 17.3 17.63C18.47 17.33 19.53 16.57 20.43 15.9C20.75 15.64 20.81 15.17 20.55 14.85C20.29 14.53 19.82 14.48 19.5 14.73V14.72Z"
        fill={color}
      />
      <path
        d="M4.38999 13.29C3.91999 13.29 3.47999 13.4 3.07999 13.59C2.87999 13.33 2.68999 13.07 2.52999 12.79C2.31999 12.43 1.85999 12.31 1.50999 12.52C1.14999 12.73 1.02999 13.19 1.23999 13.54C1.43999 13.89 1.67999 14.22 1.92999 14.54C1.54999 15.05 1.30999 15.68 1.30999 16.37C1.30999 18.07 2.68999 19.45 4.38999 19.45C5.54999 19.45 6.54999 18.8 7.07999 17.84C8.30999 19.31 8.73999 21.3 7.96999 22.61C7.75999 22.97 7.87999 23.43 8.23999 23.64C8.58999 23.85 9.05999 23.73 9.26999 23.37C10.52 21.23 9.68999 18.04 7.44999 16.08C7.29999 14.52 5.99999 13.28 4.39999 13.28L4.38999 13.29ZM4.38999 17.96C3.51999 17.96 2.80999 17.25 2.80999 16.38C2.80999 15.51 3.51999 14.8 4.38999 14.8C5.25999 14.8 5.96999 15.51 5.96999 16.38C5.96999 17.25 5.25999 17.96 4.38999 17.96Z"
        fill={color}
      />
      <path
        d="M4 5.31C4.68 4.68 5.48 4.14 6.38 3.7C6.75 3.52 6.9 3.07 6.72 2.7C6.54 2.33 6.09 2.18 5.72 2.36C4.69 2.87 3.77 3.5 2.99 4.22C2.69 4.5 2.67 4.98 2.95 5.28C3.23 5.59 3.71 5.62 4.01 5.32L4 5.31Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectLassoIcon.displayName = 'SelectLassoIcon';
